<div class="page-container">
  <form>
    <app-text-input [control]="getControl('name')" [label]="'Dein Vorname'" [placeholder]="'Dein Vorname'"></app-text-input>
    <app-text-input [control]="getControl('email')" [label]="'Deine E-Mail-Adresse'" [placeholder]="'Deine E-Mail-Adresse'" [readonly]="true"></app-text-input>
    <div class="buttons-container">
      <app-button [text]="'Änderungen speichern'" type="button" (click)="updateProfile()" [loading]="isLoading"></app-button>
    </div>
  </form>
</div>